export function postFields(arr, fieldName, value) {
    for (let i = 0; i < arr.length; i++) {
        for (let j = 0; j < arr[i].fields.length; j++) {
            if (arr[i].fields[j].propertyName === fieldName) {
                arr[i].fields[j].value = value;
            }
        }
    }
    return arr;
}